<template>
  <el-select
    :value="value"
    filterable
    clearable
    reserve-keyword
    placeholder="项目名称"
    value-key="projectId"
    :loading="loading"
    @click.native="search"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.projectId"
      :label="item.name"
      :value="item">
    </el-option>
  </el-select>
</template>
<script>
import { COMMON_PROJECT_RESOURCE_PROJECTS_DA } from '@/store/mutation-types'

export default {
  props: {
    value: [Object, String],
    subsystemId: {
      type: String,
      required: true
    },
    areaId: {
      type: Number,
    }
  },
  data() {
    return {
      /* 远程搜索项目列表 */
      loading: false,
      options: [],
    }
  },
  created() {
    if(this.value){
      this.search()
    }
  },
  methods: {
    /* 项目远程搜索 */
    search() {
      this.loading = true;
      let params = {
        subsystemId: this.subsystemId,
      }
      if(this.areaId){
        params.areaId = this.areaId;
      }
      this.$store.dispatch(COMMON_PROJECT_RESOURCE_PROJECTS_DA, params).then(data => { 
        this.loading = false
        this.options = data
      })
    },
    handleChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>
